export * from './bar-graph.component';
export * from './bar-graph.module';
